module.exports = __webpack_public_path__ + "193716dc8bec42c68628f2f65b001f73.svg";